export const EVENT_CATEGORIES = {
  CREDITS: 'Подбор кредита',
  MARKETPLACE_LOANS: 'MarketPlaceLoans',
  CREDITS_LANDING: 'Подбор кредита|Лендинг подбора',
  CREDIT_CARDS_LANDING: 'Подбор кредитной карты',
} as const;

export const EVENT_TYPES = {
  MAIN_EVENT: 'mainEvent',
  MAIN_WL_EVENT: 'mainWLEvent',
} as const;
